import React, { useState, useEffect, useCallback } from "react";

import Template from "./Profile.jsx";
import { put } from "../../util/fetch.js";
import useSkipFirstRender from "../../hooks/useSkipFirstRender.js";
import "./styles.styl";

async function updateDeliveryAddress(data, streetValue) {
  const deliveryAddressUpdateUrl = `${location.origin}/api/delivery-address/update/${data.delivery_address_id}/`;
  const body = {
    name: data.delivery_address_name,
    lastname: data.delivery_address_lastname,
    street: streetValue ?? data.delivery_address_street.split(",")[0],
    additional_info: data.delivery_address_additional_info,
    coordinates: data.coordinates,
    is_default: true,
  };
  return put(deliveryAddressUpdateUrl, { body });
}

export default function ProfileController(props) {
  const [data, setData] = useState({ ...props.customer });
  const [errors, setErrors] = useState({});

  const onChange = useCallback((e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
      message: undefined,
    }));
  }, []);

  const changeTypeOfCustomer = () => {
    setErrors();
  };

  const onSaveClick = async (streetValue) => {
    if (typeof streetValue !== "string") {
      streetValue = null;
    }
    setErrors({});
    if (
      props.isDeliveryAddress &&
      !(streetValue || data.delivery_address_street)
    ) {
      setErrors((prev) => ({
        ...prev,
        delivery_address_street: ["This field may not be blank"],
        message: "Please enter street name",
      }));
      return;
    }
    const { setIsAuthenticated, onSuccess, onError, customer, slim } = props;
    const isRegistration = slim ? false : true;
    if (isRegistration) {
      data["require_password"] = true;
    }

    try {
      const newCustomer = await put(customer.url, {
        body: streetValue
          ? { ...data, delivery_address_street: streetValue }
          : data,
      });
      setIsAuthenticated(newCustomer.is_authenticated);
      data.delivery_address_street;
      if (data["delivery_address_id"]) {
        try {
          data.coordinates =
            data.coordinates ?? props.delivery_address.coordinates;
          const newDeliveryAddress = await updateDeliveryAddress(
            data,
            streetValue,
          );

          onSuccess && onSuccess(newCustomer, newDeliveryAddress);
        } catch (err) {
          const errorData = { ...err.data };
          if (errorData.name) {
            errorData.delivery_address_name = errorData.name;
            delete errorData.name;
          }
          if (errorData.lastname) {
            errorData.delivery_address_lastname = errorData.lastname;
            delete errorData.lastname;
          }
          if (errorData.street) {
            errorData.delivery_address_street = errorData.street;
            delete errorData.street;
          }
          setErrors((prevErrors) => ({ ...prevErrors, ...errorData }));
          onError && onError(err);
        }
      } else {
        onSuccess && onSuccess(newCustomer);
      }
    } catch (err) {
      const errorData = { ...err.data };
      setErrors((prevErrors) => ({ ...prevErrors, ...errorData }));
      onError && onError(err);
    }
  };

  const updateCoordinates = useCallback((coordinates) => {
    setData((prevData) => ({ ...prevData, coordinates }));
  }, []);

  const updateStreet = useCallback((street) => {
    setData((prevData) => ({ ...prevData, delivery_address_street: street }));
  }, []);

  return (
    <Template
      {...props}
      data={data}
      changeTypeOfCustomer={changeTypeOfCustomer}
      errors={errors}
      onChange={onChange}
      onSaveClick={onSaveClick}
      updateCoordinates={updateCoordinates}
      updateStreet={updateStreet}
    />
  );
}
